import React, { useState } from "react";
import Container from "../../Layouts/Common/Container/Container";
import { useFormik } from "formik";
import { resetPassword } from "aws-amplify/auth";
import * as Yup from "yup";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
	const navigate = useNavigate();

	const [errorMessage, setErrorMessage] = useState({});
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const closeModalHandle = () => {
		setIsModalVisible(!isModalVisible);
	};

	const handleAuthError = (error) => {
		switch (error.name) {
			case "UserNotFoundException":
				return {
					message: "User does not exist. Please check the email ID.",
					title: "User Not Found",
				};
			case "InvalidParameterException":
				return {
					message: error.message,
					title: "Invalid Request",
				};
			default:
				return {
					message: error.message,
					title: "Error",
				};
		}
	};

	async function forgotPassword({ email }) {
		try {
			await resetPassword({
				username: email,
			});

			setIsLoading(false);
			navigate(`/forgot-password-verification?emailId=${email}`);
		} catch (error) {
			const err = handleAuthError(error);
			setIsLoading(false);
			setErrorMessage(err);
			setIsModalVisible(true);
		}
	}

	const formik = useFormik({
		initialValues: {
			email: "",
		},
		validationSchema: Yup.object({
			email: Yup.string()
				.email("Provide a valid Email ID.")
				.max(64, "Must be 64 characters or less.")
				.required("Email ID is Required."),
		}),
		validateOnChange: false,
		validateOnBlur: true,
		onSubmit: (values) => {
			setIsLoading(true);
			forgotPassword(values);
		},
	});

	return (
		<div>
			<Container pageName={"Forgot Password"}>
				<div className="row">
					<div className="signUpCol col-md-6">
						<div className="SignUpform">
							<form onSubmit={formik.handleSubmit} onReset={formik.resetForm}>
								<div className="form-group SignUpformFlexItem">
									<div className="ForgotPasswordEmailLabel">
										<label htmlFor="Email" className="signUpLabel required">
											Email ID
										</label>
										<input
											type="text"
											className={
												formik.touched.email && formik.errors.email
													? "form-control is-invalid"
													: "form-control"
											}
											{...formik.getFieldProps("email")}
										/>
										<div className="invalid-feedback">
											{formik.touched.email && formik.errors.email}
										</div>
									</div>
								</div>

								<div className="SignUpButtonRow">
									<button type="submit" disabled={isLoading} className="signUpButton">
										Submit
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>

				<Modal
					show={isModalVisible}
					onHide={closeModalHandle}
					backdrop="static"
					keyboard={false}
					size="md"
					aria-labelledby="contained-modal-title-vcenter"
				>
					<Modal.Header closeButton>
						{errorMessage.title}
					</Modal.Header>
					<Modal.Body>{errorMessage.message}</Modal.Body>
				</Modal>
			</Container>
		</div>
	);
};

export default ForgotPassword;